import { ReactNode } from 'react';
import { z } from 'zod';
import {
  CHART_NAME_MAX_LENGTH,
  DESCRIPTION_MAX_LENGTH,
} from '../../../../config/constants';

export interface CustomOption {
  value: string;
  label: string;
  subOptions?: CustomOption[];
  icon?: ReactNode; // Optional icon for the main option
  isDisabled?: boolean;
}

export const addReportToDashboardSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(
      CHART_NAME_MAX_LENGTH,
      `Name cannot exceed ${CHART_NAME_MAX_LENGTH} characters.`,
    ),
  description: z
    .string()
    .max(
      DESCRIPTION_MAX_LENGTH,
      `Description cannot exceed ${DESCRIPTION_MAX_LENGTH} characters.`,
    ),
  baseId: z.string().min(1, 'Dashboard is required'),
});

export type IAddReportToDashboardFormState = z.infer<
  typeof addReportToDashboardSchema
>;
